<h3>DE CIFRIS ERUDITORUM</h3>
<p> Tra le attività della De Cifris troviamo l'iniziativa De Cifris Eruditorum,
	che si prefigge di organizzare seminari su temi di ampia portata e
	cultura generale, come ad esempio l’interazione della crittografia con
	la Società, gli aspetti Legali e Giuridici, e così via. Eruditorum si
	occupa di politica, diritto e impatto culturale della crittografia.
</p>
<h5>Comitato organizzatore</h5>
<ul>
	<li> Andrea Monti, Università degli Studi Gabriele D’Annunzio di Chieti;</li>
	<li> Antonino Alì, Università di Trento;</li>
	<li> Massimiliano Sala, Università di Trento;</li>
</ul>
Per aderire all'iniziativa contattare <a href="mailto:eruditorum@decifris.
					it">eruditorum&#64;decifris.it</a>.
I coordinatori dell'iniziativa sono : Antonino Alì
(<a href="mailto:antonino.ali@unitn.it">antonino.ali&#64;unitn.it</a>) e Andrea
Monti (<a href="amonti@unich.it">amonti&#64;unich.it</a>).

<h4>EVENTI</h4>
<p>Gli eventi proposti verranno mostrati in questa sezione.</p>

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b>23 Novembre - 16:00</b>
		<ul>
			<li>
				<b>Paolo Bonavoglia</b> <br>
				<i>"Franceschini VS Partenio. Una disputa crittografica nella Venezia del Cinquecento"</i><br>
				<a
					href="../../../assets/attivita/seminariLocali/deCifrisEruditorum/11.2022-Bonavoglia.pdf">Locandina</a>
				--
				<a
					href="../../../../assets/attivita/seminariLocali/deCifrisEruditorum/11.2022-SLIDE_Bonavoglia.pdf">Slide</a>
			</li>
		</ul>
	</li>
</ul>

<h4>PROSSIMI SEMINARI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<!-- <li> 
					<b>Gennaio 2022</b>
					<ul>
						<li>
							Antonino Alì (Università di Trento), 
							Andrea Monti (Università degli Studi Gabriele D'Annunzio di Chieti) <br>
							<i>"Chi ha paura della crittografia"</i><br>
							<br>
						</li>
					</ul>
				</li> -->
</ul>

<h4>SEMINARI PASSATI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b> 25 Gennaio 2022</b>
		<ul>
			<li>
				<b>Antonino Alì</b> -- Università di Trento,
				<b>Andrea Monti</b> -- Università di Chieti-Pescara <br>
				<i>"Chi ha paura della crittografia?"</i><br>
				<a href="../../../../assets/attivita/seminariLocali/deCifris
							Eruditorum/Monti.Ali.docx.pdf">Locandina</a> --
				<a href="../../../assets/attivita/seminariLocali/deCifris
								Eruditorum/AntoninoSlide.key.pdf">Slide</a> --
				<a href="https://www.youtube.com/watch?v=ENJFHPBWWfQ">Video</a>
			</li>
		</ul>
	</li>
</ul>



<h4>VIDEO</h4>
<p> I video dell'iniziativa De Cifris Eruditorum sono disponibili sul nostro <a
		href="https://www.youtube.com/playlist?list=PLu4yxTVzRRMUMG-upX-RMu1iTtKZqjXKz">canale YouTube.</a></p>